import React from "react";
import { useState, useEffect } from 'react';

function SearchBox(props) {

  const [srchTxt, setSrchTxt] = useState('');
  useEffect(() => {
    if (props.value !== undefined) {
      setSrchTxt(props.value || '');
    }
  }, [props.value]);
  return (
    <div style={{width: props.width || "100%", height: props.height || "100%"}} >
      <input
        type="search"
        name="search-form"
        id="search-form"
        className="search-input"
        onChange={(e) => {
          setSrchTxt(e.target.value);
          props.handleSearch(e.target.value)
        }}
        placeholder={props.placeholder || "Search here"}
        style={{width: props.width || "100%", height: props.height || "100%"}}
        value={srchTxt}
      />
    </div>
  );
}

export default SearchBox;